import React from "react";
import { Link } from "gatsby";

export const MobileNavMenu = () => {
  return (
    <>
      <nav className="bg-orange text-white flex flex-col absolute w-full justify-center lg:hidden z-50">
        <ul className="w-full my-6">
          <Link to="/">
            <li className="text-center my-6 text-xl uppercase">Home</li>
          </Link>
          <Link to="/about-us">
            <li className="text-center my-6 text-xl uppercase">About Us</li>
          </Link>
          <Link to="/services">
            <li className="text-center my-6 text-xl uppercase">Our Services</li>
          </Link>
          <Link to="/projects">
            <li className="text-center my-6 text-xl uppercase">Projects</li>
          </Link>
          <Link to="/contact-us">
            <li className="text-center my-6 text-xl uppercase">Contact Us</li>
          </Link>
        </ul>
      </nav>
    </>
  );
};
